import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiResponse } from '../classes/apiResponse';


@Injectable({
    providedIn: 'root'
})
export class NotificationService extends BaseService {

    constructor(http: HttpClient) {
        super(http);
        this.entity = 'notification';
    }
    
    postMatchNotification(realmatch_id : number): Observable<ApiResponse<any>> {

        return this.http.post<ApiResponse<any>>(`${this.api}/${this.entity}/notitification-post-match/${realmatch_id}`, this.options);
    }

}
